<!-- filepath: /C:/solutions/FFB-CMS-UPGRADE/Finansforbundet.Frontend/src/vue/salary-app/src/components/BenefitPercentageBox.vue -->
<template>
  <div>
    <div class="percent-box" v-if="filteredResult && Object.keys(filteredResult).length > 0">
      <div class="items-container" :style="{ height: containerHeight }">
        <ul>
          <li v-for="[key, value] in resultsShown" :key="key">
            <div class="progress-title">{{ getBenefitItem2(key) }}</div>
            <div class="progress-bar">
              <div class="percent" :class="{ 'text-blue': value < 0.03 }">
                {{ (value * 100).toFixed(0) }}%
              </div>
              <div class="progress" :style="{ width: value * 100 + '%' }"></div>
            </div>
          </li>
        </ul>
      </div>
      <Transition
        ><button class="button button-white" v-if="!showAll && isMobile" @click="getAll">
          {{ d['Salary.BenefitsPercentages.ButtonExpand']?.item2 }}
        </button>
      </Transition>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, watch, computed } from 'vue'
import { state, localDictionary } from '@/lib/state'
import { getBenefitDictionaryItem } from '@/lib/mapping'
import { isMobile } from '@/util/screenUtil'

export default {
  setup() {
    const localState = reactive({
      filteredResult: {},
      resultsShown: [],
      showAll: false,
      isMobile: isMobile(),
      d: localDictionary(),
    })

    // TODO: check if watching state.resultData is necessary
    // Watch the global state.result and update the local filteredResult
    watch(
      () => state.resultData,
      (newResult) => {
        if (!newResult) {
          localState.filteredResult = {}
          return
        }
        // Filter out keys that do not start with 'p_'
        localState.filteredResult = Object.fromEntries(
          Object.entries(newResult).filter(([key]) => key.startsWith('p_')),
        )

        // take the first 5 items on mobile
        if (Object.keys(localState.filteredResult).length > 5 && isMobile()) {
          localState.resultsShown = Object.entries(localState.filteredResult).slice(0, 5)
        } else {
          localState.resultsShown = Object.entries(localState.filteredResult)
        }
      },
      { immediate: true },
    )

    const getBenefitItem2 = (key) => {
      const dictionaryItem = localState.d[getBenefitDictionaryItem(key)]
      return dictionaryItem ? dictionaryItem.item2 : ''
    }

    const containerHeight = computed(() => {
      if (!localState.isMobile) return 'auto'
      const itemHeight = 64 // Approximate height of each item in pixels
      return `${localState.resultsShown.length * itemHeight}px`
    })

    const getAll = () => {
      localState.showAll = true
      localState.resultsShown = Object.entries(localState.filteredResult)
    }

    return {
      ...toRefs(localState),
      getBenefitItem2,
      containerHeight,
      getAll,
    }
  },
}
</script>

<style scoped lang="postcss">
ul {
  list-style-type: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-radius: 18px;
  display: flex;
  flex-direction: column;

  @media (min-width: 1024px) {
    gap: 9px;
  }
}

.items-container {
  transition: height 0.5s ease;
  overflow: hidden;
}

.progress-title {
  text-align: left;
}

.progress-bar {
  width: 100%;
  height: 28px;
  background-color: var(--color-grey-3);
  position: relative;
  font-size: var(--font-size-body);
  font-weight: 400;

  @media (min-width: 1024px) {
    height: 24px;
  }
}

.percent {
  position: absolute;
  left: 7px;
  top: 50%;
  transform: translateY(-50%);
  color: #ffffff;

  &.text-blue {
    color: var(--color-darkblue);
  }
}

.progress {
  height: 100%;
  background-color: var(--color-darkblue);
}

.button-white {
  margin-top: 28px;
  background-color: var(--color-white);
  color: var(--color-darkblue);
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.2s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

@media (min-width: 1024px) {
  ul {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: var(--grid-gutter-2);
  }
}
</style>
